"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POS_TERMINAL_SCREEN = exports.STATUS_SCREEN = exports.CREDIT_CARD_PAYMENT_SCREEN = exports.INVOICE_SCREEN = exports.STAY_FORM_SCREEN = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Navigation_1 = __importDefault(require("../ShoppingCart/Navigation"));
const OnlineCheckinForm_1 = __importDefault(require("./OnlineCheckinForm"));
const AccountBalance_1 = __importDefault(require("./AccountBalance"));
const CreditCardPayment_1 = __importDefault(require("./CreditCardPayment"));
const StatusScreen_1 = __importDefault(require("./StatusScreen"));
const KioskAppHeader_1 = __importDefault(require("../Header/KioskAppHeader"));
const PosTerminalScreen_1 = __importDefault(require("./PosTerminalScreen"));
const useRedirectToKeyCardActivation_1 = require("../../behaviours/useRedirectToKeyCardActivation");
const Wrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1102;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
const ContentWrapper = styled_components_1.default.div `
  max-width: 520px;
  margin: 0 auto;
  padding-top: 30px;

  &.linkout-page {
    max-width: 100%;
    padding-top: 66px;
    height: 100%;
  }
`;
const dialogTypes = {
    checkinDataProcessing: {
        text: 'Thank you for your patience. Your data is being processed.',
        actionText: 'Cancel',
        showProgress: true,
    },
    serverError: {
        title: null,
        text: i18n_js_1.default.t('unknown_error_message'),
        actionText: i18n_js_1.default.t('cancel'),
        showProgress: false,
    },
};
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
exports.STAY_FORM_SCREEN = 1;
exports.INVOICE_SCREEN = 2;
exports.CREDIT_CARD_PAYMENT_SCREEN = 3;
exports.STATUS_SCREEN = 4;
exports.POS_TERMINAL_SCREEN = 5;
const OnlineCheckinFlow = ({ history, location, baseUrl, currentLocale, userData, kioskModeEnabled }) => {
    const [displayStep, setDisplayStep] = (0, react_1.useState)(exports.STAY_FORM_SCREEN);
    const [dialogIsOpen, setDialogOpen] = (0, react_1.useState)(false);
    const [dialogData, setDialogData] = (0, react_1.useState)(dialogTypes.checkinDataProcessing);
    const [headerText, setHeaderText] = (0, react_1.useState)(i18n_js_1.default.t('api_guest_journey_checkin_form_headline'));
    const [showDiscardFormDialog, setShowDiscardFormDialog] = (0, react_1.useState)(false);
    const [showSecondDiscardFormDialog, setShowSecondDiscardFormDialog] = (0, react_1.useState)(false);
    const [linkoutUrl, setLinkoutUrl] = (0, react_1.useState)(null);
    // flow population data
    const [balanceData, setBalanceData] = (0, react_1.useState)(null);
    const [creditCardData, setCreditCardData] = (0, react_1.useState)(null);
    const [adyenData, setAdyenData] = (0, react_1.useState)({});
    const [statusData, setStatusData] = (0, react_1.useState)(null);
    let pageToDisplay = react_1.default.createElement(OnlineCheckinForm_1.default, null);
    if (displayStep === exports.STAY_FORM_SCREEN) {
        pageToDisplay = (react_1.default.createElement(OnlineCheckinForm_1.default, { setDisplayStep: setDisplayStep, setDialogOpen: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.checkinDataProcessing);
            }, closeDialog: () => {
                setDialogOpen(false);
            }, setBalanceData: setBalanceData, setDialogData: setDialogData, setHeaderText: setHeaderText, setStatusData: setStatusData, linkoutUrl: linkoutUrl, setLinkoutUrl: setLinkoutUrl, openSpecificErrorDialog: message => {
                setDialogOpen(true);
                setDialogData({
                    text: message,
                    actionText: i18n_js_1.default.t('cancel'),
                    showProgress: false,
                });
            }, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            } }));
    }
    if (displayStep === exports.INVOICE_SCREEN) {
        pageToDisplay = (react_1.default.createElement(AccountBalance_1.default, { setDisplayStep: setDisplayStep, balanceData: balanceData, openDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.checkinDataProcessing);
            }, closeDialog: () => {
                setDialogOpen(false);
            }, setCreditCardData: setCreditCardData, setStatusData: setStatusData, setHeaderText: setHeaderText, openSpecificErrorDialog: message => {
                setDialogOpen(true);
                setDialogData({
                    text: message,
                    actionText: i18n_js_1.default.t('cancel'),
                    showProgress: false,
                });
            }, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            } }));
    }
    if (displayStep === exports.CREDIT_CARD_PAYMENT_SCREEN) {
        pageToDisplay = (react_1.default.createElement(CreditCardPayment_1.default, { creditCardData: creditCardData, setDisplayStep: setDisplayStep, setHeaderText: setHeaderText, setStatusData: setStatusData, setAdyenData: data => {
                localStorage.setItem('paymentReference', data.reference);
                setAdyenData(data);
            }, adyenData: adyenData, openDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.checkinDataProcessing);
            }, closeDialog: () => {
                setDialogOpen(false);
            }, setDialogData: setDialogData, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            }, openSpecificErrorDialog: message => {
                setDialogOpen(true);
                setDialogData({
                    text: message,
                    actionText: i18n_js_1.default.t('cancel'),
                    showProgress: false,
                });
            }, onPaymentFailure: data => {
                setStatusData(data);
                setDisplayStep(exports.STATUS_SCREEN);
            } }));
    }
    if (displayStep === exports.POS_TERMINAL_SCREEN) {
        pageToDisplay = (react_1.default.createElement(PosTerminalScreen_1.default, { onPaymentStatusSuccess: data => {
                if (data.nextWorkflow === 'generic_key_card') {
                    (0, useRedirectToKeyCardActivation_1.useRedirectToKeycardActivation)({ data, baseUrl, history });
                    return;
                }
                setHeaderText(data.texts.title);
                setStatusData(data);
                setDisplayStep(exports.STATUS_SCREEN);
            }, onPaymentStatusError: data => {
                setDialogOpen(true);
                setDialogData({
                    text: data.message,
                    actionText: i18n_js_1.default.t('cancel'),
                    showProgress: false,
                });
            }, openErrorDialog: () => {
                setDialogOpen(true);
                setDialogData(dialogTypes.serverError);
            } }));
    }
    if (displayStep === exports.STATUS_SCREEN) {
        pageToDisplay = react_1.default.createElement(StatusScreen_1.default, { statusData: statusData });
    }
    const handleCheckinDiscard = (action = '') => {
        if (action === 'confirm') {
            if (kioskModeEnabled) {
                history.push(`${baseUrl}/guest_journey/kiosk`);
                return;
            }
            history.push(`${baseUrl}`);
        }
        else {
            setShowDiscardFormDialog(false);
        }
    };
    (0, react_1.useEffect)(() => {
        if (location.state && location.state.accountBalance) {
            setBalanceData(location.state.accountBalance);
            setDisplayStep(exports.INVOICE_SCREEN);
        }
        return () => {
            const storedPaymentReference = localStorage.getItem('paymentReference');
            const token = kioskModeEnabled ? localStorage.getItem('kioskUserToken') : userData.token;
            const stationToken = localStorage.getItem('stationToken');
            if (storedPaymentReference) {
                apiService_1.default.cancelPaymentSesison(currentLocale, token, storedPaymentReference, kioskModeEnabled, stationToken);
                localStorage.setItem('paymentReference', '');
            }
        };
    }, []);
    const handleCancelBtn = () => {
        if (displayStep === exports.INVOICE_SCREEN) {
            setShowSecondDiscardFormDialog(true);
        }
        else if (displayStep === exports.CREDIT_CARD_PAYMENT_SCREEN) {
            setShowDiscardFormDialog(true);
        }
        else {
            history.push(`${baseUrl}`);
        }
    };
    const kioskNavAction = () => {
        if (displayStep === exports.STATUS_SCREEN) {
            history.push(`${baseUrl}/guest_journey/kiosk`);
            return;
        }
        setShowDiscardFormDialog(true);
    };
    return (react_1.default.createElement(Wrapper, null,
        displayStep !== 1 && !kioskModeEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Navigation_1.default, { icon: "close", onClick: () => {
                    handleCancelBtn();
                }, headline: headerText }),
            react_1.default.createElement(material_1.Toolbar, null))),
        kioskModeEnabled && react_1.default.createElement(KioskAppHeader_1.default, { title: headerText, navAction: kioskNavAction }),
        react_1.default.createElement(ContentWrapper, { className: linkoutUrl ? 'linkout-page' : undefined }, pageToDisplay),
        react_1.default.createElement(material_1.Dialog, { open: dialogIsOpen },
            dialogData.title && react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title" }, dialogData.title),
            react_1.default.createElement(material_1.DialogContent, null,
                dialogData.text,
                dialogData.showProgress && react_1.default.createElement(material_1.LinearProgress, null)),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setDialogOpen(false);
                        if (kioskModeEnabled) {
                            history.push(`${baseUrl}/guest_journey/kiosk`);
                            return;
                        }
                        history.replace(`${baseUrl}`);
                    } }, dialogData.actionText))),
        react_1.default.createElement(material_1.Dialog, { "data-testid": "discard-form", open: showDiscardFormDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleCheckinDiscard(), "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('dismiss_registration_title')),
            react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('dismiss_registration_text')),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => handleCheckinDiscard() }, i18n_js_1.default.t('continue_editing_button')),
                react_1.default.createElement(material_1.Button, { "data-testid": "confirm-discard", onClick: () => handleCheckinDiscard('confirm') }, i18n_js_1.default.t('dismiss_button')))),
        react_1.default.createElement(material_1.Dialog, { open: showSecondDiscardFormDialog, TransitionComponent: Transition, keepMounted: true, sx: {
                '& .MuiDialogActions-root': {
                    flexWrap: 'wrap',
                },
                '& .MuiButtonBase-root': {
                    width: '100%',
                },
            } },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t('close_form')),
            react_1.default.createElement(material_1.DialogContent, null, i18n_js_1.default.t('close_form_info')),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        if (kioskModeEnabled) {
                            history.push(`${baseUrl}/guest_journey/kiosk`);
                            return;
                        }
                        history.push(`${baseUrl}`);
                    } }, i18n_js_1.default.t('close_form_button')),
                react_1.default.createElement(material_1.Button, { onClick: () => {
                        setShowSecondDiscardFormDialog(false);
                    } }, i18n_js_1.default.t('continue_editing_button'))))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(OnlineCheckinFlow));
